import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { Pagination } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getEmpList } from "../.././Redux/action/Admin/EmployeeAction";
import Beatloader from "../../Common/Loaders/Beatloader";
import Skeleton from "react-loading-skeleton";
import SkeletonTableLoader from "../../Common/Loaders/Beatloader";
import ReactPaginate from "react-paginate";
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import { BeatLoader } from 'react-spinners';
import { Table } from "antd";
import EditEmployee from './Modal/EditEmployee';
import AddEmployee from './Modal/AddEmployee';
import ViewEmployee from "./Modal/ViewEmployee";
import { getEmployee } from "../../Redux/action/Admin/EmployeeMasterAction";
const adminMainUrl = process.env.REACT_APP_API_SERVER;
const AllEmployeeList = () => {
    const [grid, setGrid] = useState(true)
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    let { employeeData, loadingEmployeeApi } = useSelector(state => state?.EmployeeMasterReducer);


    const [editshow, seteditShow] = useState(false);

    const handleeditClose = () => seteditShow(false);

    const handleeditShow = (id) => {

        seteditShow(true)

        if (id) {
            dispatch(getEmployee(id));

        } else {
            // toast.error("Please fill personal details first.")

        }


    };

    const [viewshow, setviewShow] = useState(false);
    const handleviewClose = () => setviewShow(false);

    const handleviewShow = (id) => {

        setviewShow(true)
    };


    const columns = [
        {
            title: 'S. No.',
            dataIndex: 'S. No.',
            key: 'S. No.',
        },
        {
            title: 'Emp ID.',
            dataIndex: 'Emp ID.',
            key: 'Emp ID.',
        },
        {
            title: 'Emp Name',
            dataIndex: 'Emp Name',
            key: 'Emp Name',
        },
        {
            title: 'Role',
            dataIndex: 'Role',
            key: 'Role',
        },
        {
            title: 'Department',
            dataIndex: 'Department',
            key: 'Department',
        },
        {
            title: 'Designation',
            dataIndex: 'Designation',
            key: 'Designation',
        },
        {
            title: 'Phone No.',
            dataIndex: 'Phone No.',
            key: 'Phone No.',
        },
        {
            title: 'Email ID.',
            dataIndex: 'Email ID.',
            key: 'Email ID.',
        },
        {
            title: 'Action',
            dataIndex: 'Action',
            key: 'Action',
        },
    ];

    const [selectedRowKeys, setSelectedRowKeys] = useState([])

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }


    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(true);
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const page_no = queryParams.get("page");

    const [list, setList] = useState([]);
    const [currentPage, setCurrentPage] = useState(null); // Pages are 1-indexed
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const ITEMS_PER_PAGE = 10;

    const token = Cookies.get('token');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [])

    useEffect(() => {
        const page = page_no ? parseInt(page_no) : 1;
        setCurrentPage(page);
    }, [page_no]);

    useEffect(() => {
        if (currentPage !== null) {
            // Ensure currentPage is set before dispatching the action
            dispatch(getEmpList(currentPage, ITEMS_PER_PAGE, queryParams));
        }
    }, [currentPage, dispatch]);

    const {
        loadingEmpListApi,
        empListDataError,
        empListData,
        empListTotalPage,
        empListCurrentPage,
        empListTotalData,
    } = useSelector((state) => state?.EmployeeReducer);

    useEffect(() => {
        if (loadingEmpListApi) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (empListData) {
            setList(empListData);
        }

        if (empListCurrentPage) {
            setCurrentPage(empListCurrentPage);
        }
        if (empListTotalData) {
            setTotalItems(empListTotalData);
        }
        if (empListTotalPage) {
            setTotalPages(empListTotalPage);
        }
    }, [
        loadingEmpListApi,
        empListDataError,
        empListData,
        empListTotalPage,
        empListCurrentPage,
        empListTotalData,
    ]);

    const dataSource = list.map((employee, index) => ({
        "S. No.": index + 1,
        "Emp ID.": employee.unique_id,
        "Emp Name": (
            <h2 className="d-flex align-items-center mb-0" key={employee.id}>
                <Link to="#" className="avatar avatar-sm me-2 emp-grid-img-box">
                    {
                        employee?.profile_image ?

                            <img
                                src={`${adminMainUrl}/${employee?.profile_image}`}
                                alt="img"
                            /> :
                            <img src={`/assets/img/profiles/avatar-19.jpg`} alt="" />
                    }
                </Link>
                <Link to="#" className="d-flex flex-column">
                    <span className="text-default">{`${employee.first_name} ${employee.middle_name || ''} ${employee.last_name || ''}`}</span>
                </Link>
            </h2>
        ),
        "Role": employee.role.name || "N/A", // Replace with actual role if available
        "Department": employee.departments.name || "N/A", // Replace with actual department if available
        "Designation": employee.designation.name || "N/A", // Replace with actual designation if available
        "Phone No.": employee.contact_number || "N/A", // Replace with actual phone number if available
        "Email ID.": employee.username, // Using username as email ID
        "Action": (
            <div className="dropdown table-action" key={employee.id}>
                <Link
                    to="#"
                    className="action-icon"
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                >
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div
                    className="dropdown-menu dropdown-menu-right"
                    style={{
                        position: "absolute",
                        inset: "0px auto auto 0px",
                        margin: "0px",
                        transform: "translate3d(-99.3333px, 35.3333px, 0px)",
                    }}
                    data-popper-placement="bottom-start"
                >
                    <a
                        className="dropdown-item edit-popup"
                        onClick={() => handleeditShow(employee.id)}
                    >
                        <i className="ti ti-edit text-blue"></i> Edit
                    </a>
                    {/* <a
                        className="dropdown-item"
                        onClick={() => handleDelete(employee.id)}
                    >
                        <i className="ti ti-trash text-danger"></i> Delete
                    </a> */}
                    <a className="dropdown-item" to="#" onClick={() => handleviewShow(employee.id)}>
                        <i className="ti ti-eye text-blue-light"></i> Preview
                    </a>
                </div>
            </div>
        ),
    }));






    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1; // react-paginate uses 0-indexed pages
        // navigate(`?page=${selectedPage}`);
        // setCurrentPage(selectedPage);
        const params = new URLSearchParams(location.search);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
        setCurrentPage(selectedPage);
    };

    //search and filter data

    const parseQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            search_by: params.get("search_by") || "",
            emply_id: params.get("emply_id") || "",
            emply_name: params.get("emply_name") || "",
            department: params.get("department") || "",
            designation: params.get("designation") || "",
            contact_number: params.get("contact_number") || "",
            contact_email: params.get("contact_email") || "",
        };
    };

    let formik = useFormik({
        initialValues: parseQueryParams(),
        onSubmit: (values) => {
            const params = new URLSearchParams(location.search);
            Object.keys(values).forEach((key) => {
                if (values[key]) {
                    params.set(key, values[key]);
                } else {
                    params.delete(key);
                }
            });

            if (!params.has("page")) {
                params.set("page", "1");
            } else {
                params.set("page", "1");
            }
            const queryString = params.toString();
            navigate(`${location.pathname}?${queryString}`);
            // const currentPage = params.get('page') || 1;
            const currentPage = 1;
            const ITEMS_PER_PAGE = 10;
            dispatch(getEmpList(currentPage, ITEMS_PER_PAGE, queryString));
        },
    });

    const resetFilters = () => {
        try {
            formik.setValues({
                search_by: "",
                emply_id: "",
                emply_name: "",
                department: "",
                designation: "",
                contact_number: "",
                contact_email: "",
            });
            navigate(`/flexichain/all-employee-list?page=1`)
        } catch (error) {
            console.log(error.message);
            toast.error("Some error occured!");
        }
    };

    function formatName(firstName, middleName, lastName, maxLength = 18) {
        const fullName = `${firstName || ''} ${middleName || ''} ${lastName || ''}`.trim();

        if (fullName.length > maxLength) {
            return fullName.slice(0, maxLength - 3) + '...';
        }

        return fullName;
    }

    const tableRef = useRef(null);
    const [isGrabbing, setIsGrabbing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleMouseDown = (e) => {
        const slider = tableRef.current;
        setIsGrabbing(true);
        slider.classList.add('grabbing'); // Apply grabbing CSS class
        setStartX(e.pageX - slider.offsetLeft);
        setScrollLeft(slider.scrollLeft);
    };

    const handleMouseUp = () => {
        const slider = tableRef.current;
        setIsGrabbing(false);
        slider.classList.remove('grabbing'); // Remove grabbing CSS class
    };

    const handleMouseMove = (e) => {
        if (!isGrabbing) return;
        e.preventDefault();
        const slider = tableRef.current;
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // Speed of scroll
        slider.scrollLeft = scrollLeft - walk;
    };


    const handleDelete = (userId) => {
        try {
            let config = { headers: { "auth-token": Cookies.get('token'), 'content-type': 'multipart/form-data', } };

            axios.post(`${adminMainUrl}/api/employee/delete-employee-all-detail?user_id=${userId}`, config)
                .then(res => {
                    if (res.status === 200) {

                        toast.success(res.data.msg);

                    } else {
                        toast.error(res.data.msg);

                    }
                })
                .catch(err => {
                    console.log(err);
                    if (err.response) {
                        toast.error(err.response.data.msg);
                    } else {
                        toast.error("Internal server error.")
                    }

                });
        } catch (error) {

        }
    }




    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Employee <span className="count-title">{empListTotalData}</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="#"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Refresh"
                                            >
                                                <i className="ti ti-refresh-dot" />
                                            </a>
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            {/* Search */}
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row align-items-center">
                                    <div className="col-sm-4">
                                        <div className="icon-form mb-3 mb-sm-0">
                                            <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span>
                                            <input
                                                type="text"
                                                id="search_by"
                                                name="search_by"
                                                className="form-control"
                                                placeholder="Search"
                                                value={formik.values.search_by}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="d-flex align-items-center gap-2 flex-wrap row-gap-2 justify-content-sm-end">
                                            {/* <div className="dropdown me-2">
                                            <a
                                                href="javascript:void(0);"
                                                className="dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                            >
                                                <i className="ti ti-package-export me-2" />
                                                Export
                                            </a>
                                            <div className="dropdown-menu  dropdown-menu-end">
                                                <ul>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-file-type-pdf text-danger me-1" />
                                                            Export as PDF
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0);" className="dropdown-item">
                                                            <i className="ti ti-file-type-xls text-green me-1" />
                                                            Export as Excel{" "}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div> */}
                                            <button
                                                type="submit"
                                                className="btn btn-primary "

                                            >
                                                Search
                                            </button>
                                            <button
                                                onClick={resetFilters}
                                                className="btn btn-light "

                                            >
                                                Clear
                                            </button>
                                            <a

                                                className="btn btn-primary"
                                                onClick={handleShow}
                                            >
                                                <i className="ti ti-square-rounded-plus me-2" />
                                                Add Employee
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            {/* /Search */}
                        </div>
                        <div className="card-body">
                            {/* Filter */}
                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-sort-ascending-2 me-2" />
                                            Sort{" "}
                                        </a>
                                        <div className="dropdown-menu  dropdown-menu-start">
                                            <ul>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Ascending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Descending
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Viewed
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);" className="dropdown-item">
                                                        <i className="ti ti-circle-chevron-right me-1" />
                                                        Recently Added
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <div className="icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control bookingrange"
                                            placeholder=""
                                        />
                                    </div> */}
                                </div>
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    {/* <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="btn bg-soft-purple text-purple"
                                            data-bs-toggle="dropdown"
                                            data-bs-auto-close="outside"
                                        >
                                            <i className="ti ti-columns-3 me-2" />
                                            Manage Columns
                                        </a>
                                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                                            <h4 className="mb-2 fw-semibold">Want to manage datatables?</h4>
                                            <p className="mb-3">
                                                Please drag and drop your column to reorder your table and
                                                enable see option as you want.
                                            </p>
                                            <div className="border-top pt-3">
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Name
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-name" className="check" />
                                                        <label htmlFor="col-name" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Phone
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-phone" className="check" />
                                                        <label htmlFor="col-phone" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Email
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-email" className="check" />
                                                        <label htmlFor="col-email" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Tags
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-tag" className="check" />
                                                        <label htmlFor="col-tag" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Location
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-loc" className="check" />
                                                        <label htmlFor="col-loc" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Rating
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-rate" className="check" />
                                                        <label htmlFor="col-rate" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Owner
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-owner" className="check" />
                                                        <label htmlFor="col-owner" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Contact
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-contact"
                                                            className="check"
                                                            defaultChecked=""
                                                        />
                                                        <label htmlFor="col-contact" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Status
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-status"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-status" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Action
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-action"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-action" className="checktoggle" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="form-sorts dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            data-bs-toggle="dropdown"
                                            data-bs-auto-close="outside"
                                        >
                                            <i className="ti ti-filter-share" />
                                            Filter
                                        </a>
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                                                {/* <div className="filter-set-view"> */}

                                                <table className="content-table">
                                                    <tbody>
                                                        <tr className="">
                                                            <td>
                                                                <label htmlFor="#">Emp ID.</label>
                                                            </td>
                                                            <td className="input_box_filter w-100 ">
                                                                <input
                                                                    type="text"
                                                                    className="form-control ms-2 form-control-sm"
                                                                    placeholder="Enter Emp ID."
                                                                    name="emply_id"
                                                                    value={formik.values.emply_id}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>

                                                        <tr className="">
                                                            <td>
                                                                <label htmlFor="#">Emp Name</label>
                                                            </td>
                                                            <td className="input_box_filter w-100 ">
                                                                <input
                                                                    type="text"
                                                                    className="form-control ms-2 form-control-sm"
                                                                    placeholder="Enter Name"
                                                                    name="emply_name"
                                                                    value={formik.values.emply_name}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="">
                                                            <td>
                                                                <label htmlFor="#">Department</label>
                                                            </td>
                                                            <td className="input_box_filter w-100 ">
                                                                <input
                                                                    type="text"
                                                                    className="form-control ms-2 form-control-sm"
                                                                    placeholder="Enter Department"
                                                                    name="department"
                                                                    value={formik.values.department}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="">
                                                            <td>
                                                                <label htmlFor="#">Designation</label>
                                                            </td>
                                                            <td className="input_box_filter w-100 ">
                                                                <input
                                                                    type="text"
                                                                    className="form-control ms-2 form-control-sm"
                                                                    placeholder="Enter Designation"
                                                                    name="designation"
                                                                    value={formik.values.designation}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="">
                                                            <td>
                                                                <label htmlFor="#">Phone No.</label>
                                                            </td>
                                                            <td className="input_box_filter w-100 ">
                                                                <input
                                                                    type="text"
                                                                    className="form-control ms-2 form-control-sm"
                                                                    placeholder="Enter Phone No."
                                                                    name="contact_number"
                                                                    value={formik.values.contact_number}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="">
                                                            <td>
                                                                <label htmlFor="#">Email ID.</label>
                                                            </td>
                                                            <td className="input_box_filter w-100 ">
                                                                <input
                                                                    type="text"
                                                                    className="form-control ms-2 form-control-sm"
                                                                    placeholder="Enter Email ID."
                                                                    name="contact_email"
                                                                    value={formik.values.contact_email}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                {/* <div className="text-right d-flex justify-content-end "> */}
                                                <div className="row filter-reset-btns mt-3">
                                                    <div className="col-6">
                                                        <button
                                                            type="submit"
                                                            className=" btn btn-primary w-100"
                                                        >
                                                            Apply
                                                        </button>
                                                    </div>
                                                    <div className="col-6">
                                                        <button
                                                            onClick={resetFilters}
                                                            className="btn btn-light w-100"

                                                        >
                                                            Clear
                                                        </button>
                                                    </div>

                                                </div>
                                                {/* </div> */}
                                                {/* </div> */}
                                            </div>
                                        </form>
                                    </div>
                                    <div className="view-icons">
                                        <Link onClick={() => { setGrid(true) }} className={`${grid === true && "active"}`}>
                                            <i className="ti ti-list-tree" />
                                        </Link>
                                        <Link onClick={() => { setGrid(false) }} className={`${grid === false && "active"}`}>
                                            <i className="ti ti-grid-dots" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* /Filter */}
                            {/* Contact List */}
                            {
                                grid ?
                                    showLoader ? <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                        <BeatLoader />
                                    </div> :
                                        <div className="table-responsive custom-table">

                                            <Table className="table datanew dataTable no-footer" pagination={false}
                                                rowSelection={rowSelection} dataSource={dataSource} columns={columns} />
                                        </div> :
                                    showLoader ? <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                        <BeatLoader />
                                    </div> :
                                        <div className='row'>
                                            {
                                                list?.map((value, i) => {
                                                    return (
                                                        <div key={i} className="col-xxl-3 col-xl-4 col-md-6">
                                                            <div className="card border">
                                                                <div className="card-body">
                                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                                        <div className="d-flex align-items-center">
                                                                            <a
                                                                                href="#"
                                                                                className="avatar avatar-md flex-shrink-0 me-2 emp-grid-img-box"
                                                                            >
                                                                                {
                                                                                    value?.profile_image ?

                                                                                        <img
                                                                                            src={`${adminMainUrl}/${value?.profile_image}`}
                                                                                            alt="img"
                                                                                        /> :
                                                                                        <img src={`/assets/img/profiles/avatar-19.jpg`} alt="" />
                                                                                }
                                                                            </a>
                                                                            <div>
                                                                                <h6 className="mb-0">
                                                                                    <a
                                                                                        href="#"
                                                                                        className="fw-medium"
                                                                                    >
                                                                                        {value?.first_name} {value?.middle_name} {value?.last_name}
                                                                                    </a>
                                                                                </h6>
                                                                                <p className="text-default">{value?.role?.name}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="dropdown table-action">
                                                                            <a
                                                                                href="#"
                                                                                className="action-icon "
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <i className="fa fa-ellipsis-v" />
                                                                            </a>
                                                                            <div className="dropdown-menu dropdown-menu-right bg-white">
                                                                                <a
                                                                                    className="dropdown-item edit-popup"
                                                                                    onClick={() => handleeditShow(value.id)}
                                                                                >
                                                                                    <i className="ti ti-edit text-blue"></i> Edit
                                                                                </a>
                                                                                {/* <a
                        className="dropdown-item"
                        onClick={() => handleDelete(value.id)}
                    >
                        <i className="ti ti-trash text-danger"></i> Delete
                    </a> */}
                                                                                <a className="dropdown-item" to="#" onClick={() => handleviewShow(value.id)}>
                                                                                    <i className="ti ti-eye text-blue-light"></i> Preview
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-block">
                                                                        <div className="d-flex flex-column mb-3">
                                                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                                                                <i className="ti ti-map-pin-pin text-dark me-1" />
                                                                                {value?.unique_id}
                                                                            </p>
                                                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                                                                <i className="ti ti-mail text-dark me-1" />
                                                                                {value?.contact_email}
                                                                            </p>
                                                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                                                                <i className="ti ti-phone text-dark me-1" />
                                                                                {value?.contact_number}
                                                                            </p>

                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <span className="badge badge-tag badge-success-light me-2">
                                                                                {value?.quote_status?.name}
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                            }
                            {list.length > 0 && <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                <ReactPaginate
                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                    breakLabel="..."
                                    breakClassName="break-me"
                                    pageCount={totalPages}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    forcePage={currentPage - 1} // To sync ReactPaginate's internal state with currentPage
                                />
                            </div>}
                            {/* /Contact List */}
                        </div>
                    </div>
                </div>
            </div>
            <EditEmployee employeeData={employeeData} loadingEmployeeApi={loadingEmployeeApi} show={editshow} handleClose={handleeditClose} />
            <AddEmployee show={show} handleClose={handleClose} />
            <ViewEmployee show={viewshow} handleClose={handleviewClose} />
        </>

    )
}

export default AllEmployeeList